/**
 * Canvas display constants for Paved Results page
 *
 * Centralizes configuration for canvas rendering to allow easy testing
 * and consistent behavior across all canvas types (main, surface, base, subbase designs)
 */

/**
 * Maximum height for all canvas containers in Results page
 *
 * Applied to:
 * - 3 main canvases (UNSTABILIZED, TRAFFIC INCREASE, STABILIZED)
 * - 3 Surface Design canvases (conditional)
 * - 3 Base Design canvases (conditional)
 * - 3 Subbase Design canvases (conditional)
 *
 * Prevents excessive vertical growth when layer thicknesses are very large.
 * Canvas content will scale proportionally to fit within this height.
 *
 * @default 400 - Recommended value for optimal display
 * @example
 * // For testing different heights:
 * export const MAX_CANVAS_HEIGHT = 300; // Smaller
 * export const MAX_CANVAS_HEIGHT = 500; // Larger
 */
export const MAX_CANVAS_HEIGHT = 450;
